/* Copyright (c) 2017 Backpack Health LLC */

/* global API_BASE_URL */

import { apiRequest, authorizedApiRequest } from './apiRequest';
import ApiErrorModel from 'models/ApiErrorModel';
// import UserModel from '../models/UserModel';
import AppUtils from 'lib/AppUtils';

const api = {
  create() {
    return apiRequest('post', 'users');
  },
  checkEmailExists(email) {
    return apiRequest('head', `users?email=${encodeURIComponent(email)}`);
  },
  get(id) {
    return authorizedApiRequest('get', `users/${id}`);
  },
  update(id) {
    return authorizedApiRequest('put', `users/${id}`);
  },
  del(id) {
    return authorizedApiRequest('delete', `users/${id}`);
  },
  setMobileNumber(id) {
    return authorizedApiRequest('put', `users/${id}/mfa`);
  },
  enableMfa(id) {
    return authorizedApiRequest('delete', `users/${id}/mfa/enable`);
  },
  disableMfa(id) {
    return authorizedApiRequest('delete', `users/${id}/mfa`);
  },
  requestEmailChange(id) {
    // console.log('get subdomain');
    return authorizedApiRequest('put', `users/${id}/pendingEmail`);
  },
  deletePendingEmailChange(id) {
    // console.log('get subdomain');
    return authorizedApiRequest('delete', `users/${id}/pendingEmail`);
  },
  groupRoles(id) {
    return authorizedApiRequest('get', `users/${id}/groupRoles`);
  },
};

const userApi = {
  create(userData) {
    const data = _.assign(
      {},
      { subdomain: AppUtils.getSubdomain() },
      userData
    );
    return api.create()(data).then(res => res.data.data);
  },

  checkEmailExists(email) {
    return api.checkEmailExists(email)().then(res => res.status === 204);
  },

  activate(userId, token, password) {
    return api.activate(userId, token)({ password }).then(res => res.data.data);
  },

  get(userId) {
    return api.get(userId)().then(res => res.data.data);
  },

  update(userData) {
    return api.update(userData.id)(userData).then(res => null);
  },

  del(userId) {
    return api.del(userId)().then(res => null);
  },

  setMobileNumber(userId, mfaSettings) {
    return api.setMobileNumber(userId)(mfaSettings).then(res => null);
  },

  enableMfa(userId, mfaSettings) {
    return api.enableMfa(userId)(mfaSettings).then(res => null);
  },

  disableMfa(userId) {
    return api.disableMfa(userId)().then(res => null);
  },

  requestEmailChange(userId, email, subdomain, group_id) {
    return new Promise((res) => {
      api.requestEmailChange(userId)({
        email,
        subdomain,
        group_id,
      }).then(() => {
        authorizedApiRequest('post', `users/${userId}/email/verify`)({ subdomain: AppUtils.getSubdomain() })
          .then((err, payload) => {
            res(payload);
          });
      });
    });
  },

  deletePendingEmailChange(userId) {
    return api.deletePendingEmailChange(userId)().then(res => null);
  },

  getGroupRoles(userId) {
    return api.groupRoles(userId)().then(res => res.data.data);
  },

};

export default userApi;
